import dayjs from "dayjs";

export function formatCurrency(val) {
  const n = Number(val || 0);
  const neg = n < 0;
  const [intPart, decPart] = Math.abs(n).toFixed(2).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return (neg ? "-€ " : "€ ") + grouped + "," + decPart;
}

export function formatDate(date) {
  if (!date) return "";
  return dayjs(date).format("DD/MM/YYYY");
}

export const MONTH_NAMES = [
  "",
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

export function todayISO() {
  return dayjs().format("YYYY-MM-DD");
}
